export const TIPOS_IMOVEL = [
    { id: 'lote', label: 'Lote', icon: 'mdi:vector-square', destino: 'ambos' },
    { id: 'cobertura', label: 'Cobertura', icon: 'mdi:terrain', destino: 'residencial' },
    { id: 'galpao', label: 'Galpão', icon: 'mdi:warehouse', destino: 'comercial' },
    { id: 'loja-sobreloja', label: 'Loja e sobreloja', icon: 'mdi:storefront-outline', destino: 'comercial' },
    { id: 'sobreloja', label: 'Sobreloja', icon: 'mdi:storefront-outline', destino: 'comercial' },
    { id: 'predio-comercial', label: 'Prédio comercial', icon: 'mdi:office-building-outline', destino: 'comercial' },
    { id: 'barracao', label: 'Barracão', icon: 'mdi:home-silo-outline', destino: 'comercial' },
    { id: 'apartamento', label: 'Apartamento', icon: 'mdi:home-city-outline', destino: 'residencial' },
    { id: 'sala', label: 'Sala', icon: 'mdi:door-open', destino: 'comercial' },
    { id: 'terraco', label: 'Terraço', icon: 'mdi:balcony', destino: 'ambos' },
    { id: 'apto-comercial', label: 'Apto. Comercial', icon: 'mdi:office-building-outline', destino: 'comercial' },
    { id: 'loja', label: 'Loja', icon: 'mdi:store-outline', destino: 'comercial' },
    { id: 'andar-corrido', label: 'Andar corrido', icon: 'mdi:office-building-outline', destino: 'comercial' },
    { id: 'imovel-comercial', label: 'Imóvel comercial', icon: 'mdi:storefront-outline', destino: 'comercial' },
    { id: 'predio', label: 'Prédio', icon: 'mdi:office-building', destino: 'ambos' },
    { id: 'sobrado', label: 'Sobrado', icon: 'mdi:home-modern', destino: 'residencial' },
    { id: 'chacara', label: 'Chácara', icon: 'mdi:pine-tree', destino: 'residencial' },
    { id: 'estacionamento', label: 'Estacionamento', icon: 'mdi:parking', destino: 'comercial' },
    { id: 'loja-galpao', label: 'Loja e Galpão', icon: 'mdi:warehouse', destino: 'comercial' },
    { id: 'casa-comercial', label: 'Casa Comercial', icon: 'mdi:home-city', destino: 'comercial' },
    { id: 'kitnet', label: 'Kitnet', icon: 'mdi:bed-single-outline', destino: 'residencial' },
    { id: 'casa', label: 'Casa', icon: 'mdi:home-outline', destino: 'residencial' },
    { id: 'sitio', label: 'Sítio', icon: 'mdi:barn', destino: 'residencial' },
];

export const TIPOS_BY_ID = TIPOS_IMOVEL.reduce((acc, t) => {
    acc[t.id] = t;
    return acc;
}, {});

export function buildInitialWorkflow() {
    const root = {
        id: 'root',
        type: 'rootNode',
        position: { x: 0, y: 0 },
        data: { label: 'Início da coleta', perguntas: [] },
    };

    const finalidade = {
        id: 'finalidade',
        type: 'finalidadeNode',
        position: { x: 0, y: 150 },
        data: {
            label: 'Venda / Aluguel',
            icon: 'mdi:swap-horizontal',
            finalidade: 'ambos',
            perguntas: [],
        },
    };

    const destinos = [
        { id: 'comercial', destino: 'comercial', x: -260, tiposIniciais: ['loja', 'sala'] },
        { id: 'residencial', destino: 'residencial', x: 260, tiposIniciais: ['casa', 'apartamento'] },
    ];

    const destinoNodes = destinos.map((d) => ({
        id: d.id,
        type: 'destinoNode',
        position: { x: d.x, y: 310 },
        data: {
            label: d.destino === 'comercial' ? 'Comercial' : 'Residencial',
            icon: d.destino === 'comercial' ? 'mdi:storefront-outline' : 'mdi:home-outline',
            destino: d.destino,
            perguntas: [],
        },
    }));

    const tipoNodes = destinos.flatMap((d) =>
        d.tiposIniciais.map((tipoId, idx) => {
            const tipo = TIPOS_BY_ID[tipoId];
            const offsetX = (idx - (d.tiposIniciais.length - 1) / 2) * 200;
            return {
                id: `${d.id}_${tipoId}`,
                type: 'tipoNode',
                position: { x: d.x + offsetX, y: 470 },
                data: {
                    label: tipo.label,
                    icon: tipo.icon,
                    tipoId,
                    destino: d.destino,
                    perguntas: [],
                },
            };
        })
    );

    const nodes = [root, finalidade, ...destinoNodes, ...tipoNodes];

    const edges = [
        { id: 'e_root_finalidade', source: 'root', target: 'finalidade' },
        ...destinos.map((d) => ({ id: `e_finalidade_${d.id}`, source: 'finalidade', target: d.id })),
        ...destinos.flatMap((d) =>
            d.tiposIniciais.map((tipoId) => ({
                id: `e_${d.id}_${tipoId}`,
                source: d.id,
                target: `${d.id}_${tipoId}`,
            }))
        ),
    ];

    return { nodes, edges };
}
